import { makeStyles, Tab, Tabs } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  tab: {
    color: theme.palette.grey["900"],
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: 400,
    maxWidth: 500,
    padding: 0,
  },
  tabSelected: {
    color: theme.palette.primary.main,
  },
  flexContainer: {
    borderBottom: "none",
    "& .MuiTab-wrapper": {
      flexDirection: "row",
      justifyContent: "flex-start",
    },
    "& .MuiTab-textColorInherit": {
      opacity: 1,
    },
  },
  indicator: {
    height: "0 !important",
  },
}));

export const VerticalTabs = ({
  tab,
  setTab,
  tabNames,
  additionalComponent,
}) => {
  const classes = useStyles();

  return (
    <Tabs
      orientation="vertical"
      value={tab}
      onChange={(event, newValue) => setTab(newValue)}
      classes={{
        flexContainer: classes.flexContainer,
        indicator: classes.indicator,
      }}
    >
      {tabNames.map((tabName, index) => (
        <Tab
          key={index}
          label={tabName}
          classes={{ root: classes.tab, selected: classes.tabSelected }}
        />
      ))}
      {additionalComponent}
    </Tabs>
  );
};
